import { EMAIL_TOKENS } from "../../styles/tokens";

import { CSSProperties } from "react";

export function getListStyles(listType: "bullet" | "ordered"): CSSProperties {
  return {
    fontFamily: EMAIL_TOKENS.fontFamily.sans,
    fontSize: EMAIL_TOKENS.fontSize.base,
    lineHeight: EMAIL_TOKENS.lineHeight.normal,
    color: EMAIL_TOKENS.colors.text.primary,
    margin: "0",
    padding: "0",
    paddingLeft: "24px",
    listStyleType: listType === "bullet" ? "disc" : "decimal",
  };
}

export function getListItemStyles(): CSSProperties {
  return {
    fontFamily: EMAIL_TOKENS.fontFamily.sans,
    fontSize: EMAIL_TOKENS.fontSize.base,
    lineHeight: EMAIL_TOKENS.lineHeight.normal,
    color: EMAIL_TOKENS.colors.text.primary,
    margin: "0",
    padding: "0",
    paddingBottom: "4px",
  };
}
